<template>
  <!-- 学术研究 -->
  <div class="brabdHonorsPage">
    <!-- 头部 -->
    <headerNav activeIndex="brandHonors" @setBanner="setBanner"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="pc maxWidth" id="mainNav" style="margin: 20px auto">
      <div class="CERTIFICATENav" ref="CERTIFICATENav" id="CERTIFICATENav">
        <div>
          <div
            class="Regular"
            style="color: #000000; font-size: 32px; line-height: 32px"
          >
            品牌荣誉
          </div>
          <div
            style="
              color: #7d7d7d;
              font-size: 15px;
              line-height: 15px;
              margin-top: 11px;
            "
          >
            BRAND HONORS
          </div>
          <div style="margin-top: 24px">
            国家卫健委“十四五”规划全国重点课题研究
          </div>
        </div>
        <div class="CERTIFICATENav-content">
          <div
            v-for="(item, index) of honorsQualificationsList"
            :key="index"
            class="img"
            style="width: 46%; margin-bottom: 40px"
          >
            <div class="Regular enlarge" style="color: #719468; width: 100%">
              <img
                :src="getUrlPrefix(item.images)"
                style="width: 100%"
                alt=""
              />
            </div>
            <div
              class="Regular"
              style="
                text-align: center;
                margin-top: 20px;
                font-size: 20px;
                line-height: 26px;
                color: #434343;
              "
            >
              {{ item.name }}
            </div>
          </div>
          <div
            style="width: 100%; margin-top: 42px"
            class="ql-editor"
            v-html="honorsQualifications.configValue"
          ></div>
        </div>
        <div></div>
      </div>
      <!-- 新华社专题报道 -->
      <div class="CERTIFICATENav" style="background:#f9f9f9;">
        <div>
          <div
            class="Regular"
            style="color: #000000; font-size: 32px; line-height: 32px"
          >
            新华社专题报道
          </div>
        </div>
        <div
          style="padding: 59px 90px 0"
          class="ql-editor"
          v-html="specialReport.configValue"
        ></div>
      </div>
    </div>

    <div class="mobile">
      <div
        style="background: #f9f9f9; padding: 10px"
        id="CERTIFICATENavM"
      >
        <div
          style="
            margin: 0 auto 0;
            padding: 0.26rem 0 0.2rem;
            text-align: center;
          "
        >
          <div
            style="
              font-size: 0.34rem;
              line-height: 1.4;
              color: #ddd;
              font-weight: 400;
              font-family: 'Proxima-Bold', sans-serif;
              text-transform: uppercase;
            "
          >
            BRAND HONORS
          </div>
          <div
            style="color: #0f3a3c; font-weight: 600; margin-top: -4px"
            class="fzTitle"
          >
            品牌荣誉
          </div>
          <div style="margin-top: 24px; font-size: 0.18rem">
            国家卫健委“十四五”规划全国重点课题研究
          </div>
        </div>
        <div
          style="display: flex; justify-content: space-around; flex-wrap: wrap"
        >
          <div
            v-for="(item, index) of honorsQualificationsList"
            :key="index"
            style="width: 46%; margin-bottom: 0.05rem"
          >
            <div class="Regular" style="color: #719468; width: 100%">
              <img
                :src="getUrlPrefix(item.images)"
                style="width: 100%"
                alt=""
              />
            </div>
            <div
              class="Regular"
              style="
                text-align: center;
                margin-top: 0.1rem;
                font-size: 0.14rem;
                color: #434343;
              "
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div
          style="width: 100%; margin-top: 42px"
          class="ql-editor"
          v-html="honorsQualifications.configValue"
        ></div>
      </div>
      <!-- 新华社专题报道 -->
      <div>
        <div>
          <div
            style="
              color: #0f3a3c;
              font-weight: 600;
              margin-top: 0.2rem;
              text-align: center;
            "
            class="fzTitle"
          >
            新华社专题报道
          </div>
        </div>
        <div
          style="padding: 0.2rem; font-size: 0.16rem"
          class="ql-editor editor"
          v-html="specialReport.configValue"
        ></div>
      </div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import $ from "jquery";
import headerNav from "@/components/headerNav/index";
import bannerNav from "@/components/banner/index";
import footerNav from "@/components/footerNav/index";
import { getAboutUsListByType } from "@/api/aboutUs";
import { getConfByKey } from "@/api/common";

export default {
  name: "academicCenter",
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: "",
      }, //轮播图

      honorsQualificationsList: [], //科研成果数据集合
      honorsQualifications: {}, //科研成果参数对象
      specialReport: {}, //专题报告对象
    };
  },
  mounted() {
    this.mobile = this.isMobile();
    if (this.isMobile() === true) {
      this.postMessage(
        "御方汇植物化妆品原料【官网】",
        "新闻中心",
        window.location.href,
        this.getUrlPrefix(this.getBaseInfo().logo)
      );
    }
    this.getData();
  },
  methods: {
    setBanner(url, mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      };
    },
    getScroll() {
      var aboutUsIndex = document.getElementById("mainNav").offsetTop;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.mobile === false) {
        this.show = aboutUsIndex - 200 < scrollTop;
      }
    },
    goHome() {
      this.$router.push({ name: "home" });
    },
    getData() {
      getAboutUsListByType({ type: 3 }).then((response) => {
        this.honorsQualificationsList = response.data;
      });
      //查询科研成果参数维护
      getConfByKey({ key: 'sys.aboutUs.honorsQualifications' }).then(
        (response) => {
          this.honorsQualifications = response.data
        }
      )
      //查询专题报告
      getConfByKey({ key: "sys.aboutUs.specialReport" }).then((response) => {
        this.specialReport = response.data;
      });
    },
  },

  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
};
</script>

<style lang="scss">
.brabdHonorsPage {
  .maxWidth {
    width: 1080px;
    margin: 0 auto;
  }
  .CERTIFICATENav {
    position: relative;
    padding: 40px 0;
    margin: 0 auto;
    text-align: center;
    background: #fff;
    .CERTIFICATENav-content {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 0px 90px;
      margin: 30px 20px 0;
      zoom: 0.9;
      .img {
        margin-right: 4%;
      }
      .img:nth-child(2n) {
        margin-right: 0;
      }
      .title {
        color: #000000;
        font-size: 23px;
        line-height: 23px;
        text-align: center;
        margin: 22px 0 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/brandHonors/index.vue